import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { ModuleCompletedView } from '../../views';

export const exerciseData1Completed: ExerciseData = {
    ExerciseView: Module1Completed,
    dataKeys: [],
    questions: [],
};

function Module1Completed({ exercise, onContinue }: ExerciseViewProps) {
    return (
        <ModuleCompletedView onContinue={onContinue}>
            Du har nu lavet øvelserne i modul 1, og næste skridt er at mødes med
            din psykolog. Herefter vil du få adgang til modul 2. Hvis du har
            lyst, så tag et øjeblik og anerkend dig selv for din indsats.
        </ModuleCompletedView>
    );
}
